export const themeTextRed = '#FF3188';